Ext.define('SA.lq.SearchResult', {
    constructor({columnCfgs, geoUnit, data}) {
        this.columnCfgs = columnCfgs;
        this.geoUnit = geoUnit;
        this.data = data;
    },

    getColumnCfgs() {
        return this.columnCfgs;
    },

    getGeoUnit() {
        return this.geoUnit;
    },

    getResultCount() {
        return this.data.length;
    },

    hasData() {
        return this.getResultCount() > 0;
    },

    mapData(cb) {
        return this.data.map(cb);
    }
});